import React from 'react';
import { Link } from 'react-router-dom';

const AuthLayout = ({ children, showBackButton = false }) => {
  return (
    <div id="auth-section" className="relative flex h-screen w-full overflow-hidden route-container">
      {/* Unified Gradient Background - matches RoleSelectionPage */}
      <div className="absolute inset-0 bg-gradient-to-r from-violet-600 via-cyan-500 via-pink-500 to-slate-700" />

      {/* Animated Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-600/20 via-transparent to-blue-600/20 animate-gradient" />

      {/* Mesh Pattern Overlay */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Main Content Container - Centered */}
      <div className="relative w-full h-full flex items-center justify-center p-4 md:p-8">
        {/* Back Button - Positioned absolute */}
        {showBackButton && (
          <Link
            to="/"
            className="absolute top-6 left-6 z-10 text-white hover:bg-white/30 rounded-full p-3 transition-all duration-300
                       backdrop-blur-md border-2 border-white/40 hover:scale-110 shadow-xl flex items-center gap-2"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
            </svg>
          </Link>
        )}

        {/* Content Card - Scrollable and fits within viewport */}
        <div className="relative bg-white/95 backdrop-blur-xl rounded-[2rem] shadow-2xl p-6 md:p-8 max-w-md w-full max-h-[calc(100vh-2rem)] md:max-h-[calc(100vh-4rem)] overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout; 